import React from "react";

const Scroll = (props) => {
    return (
        <div className="scroll-container">
            {props.children}
        </div>
    );
};

export default Scroll;